
export const reset = (() => {

    const resetBtn = document.getElementById("filter-reset");

    if (!resetBtn) return;

    resetBtn.addEventListener("click", function () {
       window.location = window.location.pathname
    });

})();
